import { apiRequest, ajaxWatched } from '../../shared/services';

export const RECORDS_RECEIVE_RECORDS = 'RECORDS_RECEIVE_RECORDS';
export const RECORDS_CREATE_RECORD = 'RECORDS_CREATE_RECORD';
export const RECORDS_EDIT_RECORD = 'RECORDS_EDIT_RECORD';
export const RECORDS_SHOW_SAVE_RESULT = 'RECORDS_SHOW_SAVE_RESULT';


function receiveRecords(json){
    return {
        type: RECORDS_RECEIVE_RECORDS,
        availableRecords: json
    };
}

function receiveNewRecord(json) {
    return {
        type: RECORDS_CREATE_RECORD,
        selectedRecord: {
            ...json.record,
            collection: json.collection
        }
    };
}

function showSaveResult(json) {
    return {
        type: RECORDS_SHOW_SAVE_RESULT,
        saveResult: {
            ...json
        }
    };
}

function receiveRecord(json) {
    return {
        type: RECORDS_EDIT_RECORD,
        selectedRecord: {
            ...json.record,
            collection: json.collection
        }
    };
}

export function fetchRecords(collectionId){
    var rt = {};
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, '/api/record/find/' + collectionId)
                .then(json => dispatch(receiveRecords(json)))
        ));
    };
}

export function createRecord(collectionId){
    var rt = {}
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, '/api/record/new/' + collectionId)
                .then(json => dispatch(receiveNewRecord(json)))

        ));
    };
}

export function getRecord(recordId) {
    var rt = {}
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, '/api/record/id/' + recordId)
                .then(json => dispatch(receiveRecord(json)))
        ));
    }
}

export function saveRecord(collectionId, recordId, data) {
    var rt = {}
    var resource = '/api/record/save/' + collectionId;
    var method = 'POST';

    if (recordId) {
        resource += '/' + recordId;
        method = 'PUT';
    }

    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, resource, {method: method, body: JSON.stringify(data)})
                .then(json => dispatch(showSaveResult(json)))
        ));
    };
}